<template>
  <form>
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <h1 v-if="userIsTalent">Manage Payment Details</h1>
        <h1 v-else-if="userIsManager">Default Payment Details</h1>

        <a @click="$router.go(-1)" class="btn btn-info" active-class="">
          <i class="fa fa-chevron-left"></i> Back
        </a>
      </div>
    </div>

    <div class="container-fluid">
      <div class="dashboard-block">

        <div class="panel panel-grey">
          <div class="panel-body">
            <div class="form-horizontal">
              <div :class="$hasErrorClass($v.stateBsbNumber, 'form-group')" v-if="user.region.shortname === $regionNameAu">
                <label class="col-sm-4 col-lg-3 control-label">BSB Number:</label>
                <div class="col-sm-8 col-lg-5">
                  <input type="text" class="form-control" v-model="$v.stateBsbNumber.$model">
                  <vuelidate-help label="BSB" :field="$v.stateBsbNumber"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 col-lg-3 control-label">Account Name:</label>
                <div class="col-sm-8 col-lg-5">
                  <input type="text" class="form-control" v-model="$v.stateAccountName.$model">
                </div>
              </div>

              <div :class="$hasErrorClass($v.stateAccountNumber, 'form-group')">
                <label class="col-sm-4 col-lg-3 control-label">Account Number:</label>
                <div class="col-sm-8 col-lg-5">
                  <input
                    name="account_number"
                    type="text"
                    class="form-control"
                    v-model="$v.stateAccountNumber.$model">
                  <vuelidate-help label="Account number" :field="$v.stateAccountNumber"/>
                </div>
              </div>

              <div class="form-group" v-if="user.region.shortname === $regionNameUk">
                <label class="col-sm-4 col-lg-3 control-label">Sort Code:</label>
                <div class="col-sm-8 col-lg-5">
                  <input type="text" class="form-control" v-model="$v.stateSortCode.$model">
                </div>
              </div>

              <div class="form-group" v-if="user.region.shortname === $regionNameUk">
                <label class="col-sm-4 col-lg-3 control-label">Bank Name:</label>
                <div class="col-sm-8 col-lg-5">
                  <input type="text" class="form-control" v-model="$v.stateBankName.$model">
                </div>
              </div>

              <div class="form-group" v-if="user.region.shortname === $regionNameUk">
                <label class="col-sm-4 col-lg-3 control-label">Bank Address:</label>
                <div class="col-sm-8 col-lg-5">
                  <input type="text" class="form-control" v-model="$v.stateBankAddress.$model">
                </div>
              </div>

              <div v-if="user.region.shortname === $regionNameUs"
                   :class="$hasErrorClass($v.stateABARoutingNumber, 'form-group')">
                <label class="col-sm-4 col-lg-3 control-label">ABA Routing Number:</label>
                <div class="col-sm-8 col-lg-5">
                  <input
                    name="aba_routing_number"
                    type="text"
                    class="form-control"
                    v-model="$v.stateABARoutingNumber.$model">
                  <vuelidate-help label="ABA routing number" :field="$v.stateABARoutingNumber"/>
                </div>
              </div>

              <div class="form-group" v-if="$soleTrader && (userIsTalent || userIsManager)">
                <label class="col-sm-4 col-lg-3 control-label">Are you a sole trader?</label>
                <div class="col-sm-8 col-lg-5">
                  <selectize
                    name="sole_trader"
                    class="selectize selectize-single"
                    :options="booleanOptions"
                    v-model="$v.stateSoleTrader.$model">
                  </selectize>
                </div>
              </div>

              <div class="form-group" v-if="user.region.shortname === $regionNameAu" :class="$hasErrorClass($v.stateAbn, 'form-group')">
                <label class="col-sm-4 col-lg-3 control-label">ABN:</label>
                <div class="col-sm-8 col-lg-5">
                  <input type="text" class="form-control" v-model="$v.stateAbn.$model" >
                  <vuelidate-help label="ABN" :field="$v.stateAbn"/>
                </div>
              </div>

              <div class="form-group" v-if="$statementBySupplier && (userIsTalent || userIsManager)">
                <label class="col-sm-4 col-lg-3 control-label">Upload statement by supplier</label>
                <div class="col-sm-8 col-lg-5">
                  <file-input
                    name="statement_by_supplier"
                    v-model="$v.stateStatementBySupplier.$model"
                    :prefix="'profile-payment-details'"
                    data-vv-as="Statement by supplier"/>
                </div>
              </div>

              <div v-if="$superannuationNumber" :class="$hasErrorClass($v.stateMemberFund, 'form-group')">
                <label class="col-sm-4 col-lg-3 control-label">Superannuation Fund:</label>
                <div class="col-sm-8 col-lg-5">
                  <input
                    name="member_fund"
                    type="text"
                    class="form-control"
                    data-vv-as="member_fund"
                    v-model="$v.stateMemberFund.$model">
                  <vuelidate-help label="Superannuation Fund" :field="$v.stateMemberFund"/>
                </div>
              </div>

              <div v-if="$isACA" :class="$hasErrorClass($v.stateSuperAnnuationFundABN, 'form-group')">
                <label class="col-sm-4 col-lg-3 control-label">Superannuation Fund ABN:</label>
                <div class="col-sm-8 col-lg-5">
                  <input
                    name="superannuation_number_abn"
                    type="text"
                    class="form-control"
                    data-vv-as="superannuation_number_abn"
                    v-model="$v.stateSuperAnnuationFundABN.$model">
                  <vuelidate-help label="Superannuation Fund ABN" :field="$v.stateSuperAnnuationFundABN"/>
                </div>
              </div>

              <div v-if="$superannuationNumber" :class="$hasErrorClass($v.stateMemberNumber, 'form-group')">
                <label class="col-sm-4 col-lg-3 control-label">Member Number:</label>
                <div class="col-sm-8 col-lg-5">
                  <input
                    name="member_number"
                    type="text"
                    class="form-control"
                    data-vv-as="member number"
                    v-model="$v.stateMemberNumber.$model">
                  <vuelidate-help label="Member Number" :field="$v.stateMemberNumber"/>
                </div>
              </div>

              <div v-if="$superannuationNumber" :class="$hasErrorClass($v.stateSpinNumber, 'form-group')">
                <label class="col-sm-4 col-lg-3 control-label">Spin Number:</label>
                <div class="col-sm-8 col-lg-5">
                  <input
                    name="spin_number"
                    type="text"
                    class="form-control"
                    data-vv-as="spin number"
                    v-model="$v.stateSpinNumber.$model">
                  <vuelidate-help label="Spin Number" :field="$v.stateSpinNumber"/>
                </div>
              </div>
              <div class="form-group" v-if="(userIsManager)">
                <label class="col-sm-4 col-lg-3 control-label">Allow stars to add their own payment details</label>
                <div class="col-sm-8 col-lg-5">
                  <selectize
                    name="allow_talent_change"
                    class="selectize selectize-single"
                    :options="booleanOptions"
                    v-model="$v.stateAllowTalentChange.$model">
                  </selectize>
                </div>
              </div>
              <!-- Only Talent Can Answer -->
              <div class="form-group" v-if="(!$vlastMode && (user.region.shortname === $regionNameAu || user.region.shortname === $regionNameUk) && (userIsTalent || userIsManager)) || ($vlastMode && user.region.shortname === $regionNameAu && (userIsTalent || userIsManager))">
                <label class="col-sm-4 col-lg-3 control-label">{{ $t('Are you tax registered?') }}</label>
                <div class="col-sm-8 col-lg-5">
                  <selectize
                    name="gst_registered"
                    class="selectize selectize-single"
                    :options="booleanOptions"
                    v-model="$v.stateGstRegistered.$model">
                  </selectize>
                </div>
              </div>

              <div class="form-group" v-if="this.paymentDetails.managers_details" >
                <div class="col-sm-12 col-lg-8">
                  <p class="text-danger pull-right" >Managers Details</p>
                </div>
              </div>

              <div class="form-group" v-if="!$isACA">
                <div class="col-sm-12 col-lg-6 col-lg-offset-3">
                  <h3>Optional</h3>
                  <p class="subtext">To be booked for opportunities from around the world please provide</p>
                </div>
              </div>

              <div v-if="$swiftCode" :class="$hasErrorClass($v.stateSwiftCode, 'form-group')">
                <label class="col-sm-4 col-lg-3 control-label">Swift Code:</label>
                <div class="col-sm-8 col-lg-5">
                  <input
                    name="swift_code"
                    type="text"
                    class="form-control"
                    v-model="$v.stateSwiftCode.$model">
                  <vuelidate-help label="Swift code" :field="$v.stateSwiftCode"/>
                </div>
              </div>

              <div v-if="user.region.shortname === $regionNameUk" :class="['form-group', errorClass('iban_number')]">
                <label class="col-sm-4 col-lg-3 control-label">IBAN Number:</label>
                <div class="col-sm-8 col-lg-5">
                  <input
                    name="iban_number"
                    type="text"
                    class="form-control"
                    v-model="$v.stateIBANNumber.$model">
                  <vuelidate-help label="IBAN number" :field="$v.stateIBANNumber"/>
                </div>
              </div>
            </div>
          </div>

          <div class="panel-footer">
            <ladda-button
              type="submit"
              class="btn btn-sm btn-primary"
              :click="handleSavePaymentDetailsCallback">
              Save Payment Details
            </ladda-button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import {omit} from 'lodash'
import {stateMapper} from 'mixins/users/payment-details'
import {handleServerErrors} from 'utils/http'
import {helpers} from 'mixins/users'
import {helpers as profileHelpers} from 'mixins/profile'
import Selectize from '../ext/codium/CodiumSelectize'
import {notify} from 'utils'
import FileInput from '../misc/FileInput'
import {helpers as validationHelpers, maxLength, minLength, numeric, requiredIf, decimal} from 'vuelidate/lib/validators'
import VuelidateHelp from '../misc/VuelidateHelp'

const swiftCode = validationHelpers.regex('swiftCode', /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/)
const ibanNumber = validationHelpers.regex('ibanNumber', /^[A-Za-z]{2}[0-9]{2}([A-Za-z0-9]{15,35})$/)
const validBSB = validationHelpers.regex('BSB', /^\d{3}-?\d{3}$/)
const validSPIN = validationHelpers.regex('SPIN', /^[A-Za-z]{3}[0-9]{4}([A-Za-z]{2})$/)
const validABN = function (abn) {
  if (!abn) {
    return true
  }

  let isValid = true

  // remove all spaces
  abn = abn.replace(/\s/g, '')

  // 0. ABN must be 11 digits long
  isValid &= abn && /^\d{11}$/.test(abn)

  if (isValid) {
    let weightedSum = 0
    let weight = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19]

    // Rules: 1,2,3
    for (let i = 0; i < weight.length; i++) {
      weightedSum += (parseInt(abn[i]) - ((i === 0) ? 1 : 0)) * weight[i]
    }

    // Rules: 4,5
    isValid &= ((weightedSum % 89) === 0)
  }

  return isValid
}

export default {
  mixins: [helpers, stateMapper, profileHelpers],

  validations () {
    return {
      stateBsbNumber: {
        validBSB
      },
      stateAccountName: {},
      stateAccountNumber: {
        numeric
      },
      stateSortCode: {},
      stateBankName: {},
      stateBankAddress: {},
      stateABARoutingNumber: {
        numeric,
        minLength: minLength(9),
        maxLength: maxLength(9)
      },
      stateAbn: {
        validABN
      },
      stateAllowTalentChange: {},
      stateGstRegistered: {},
      stateSwiftCode: {
        swiftCode
      },
      stateIBANNumber: {
        ibanNumber
      },
      stateSoleTrader: {},
      stateStatementBySupplier: {},
      stateMemberFund: {
        required: requiredIf(function () { return this.$superannuationNumber && !this.isSoleTrader })
      },
      stateSuperAnnuationFundABN: {
        decimal,
        requiredIf: requiredIf(() => { return this.$isACA && !this.isSoleTrader })
      },
      stateSpinNumber: {
        required: requiredIf(function () { return this.$superannuationNumber && this.isSoleTrader }),
        validSPIN
      },
      stateMemberNumber: {
        required: requiredIf(function () { return this.$superannuationNumber && this.isSoleTrader })
      }
    }
  },

  components: {
    Selectize,
    FileInput,
    VuelidateHelp
  },

  created () {
    this.loadPaymentDetails()
  },

  watch: {
    user: 'loadPaymentDetails'
  },

  computed: {
    ...mapState('user', ['user']),
    /**
     * Boolean options for dropdowns that answers Yes/No.
     *
     * @return array
     */
    booleanOptions () {
      return [
        { id: true, text: 'Yes' },
        { id: false, text: 'No' }
      ]
    },

    isSoleTrader () {
      return this.stateSoleTrader === 1
    }
  },

  methods: {
    ...mapActions('user/paymentDetail', ['getUserPaymentDetails', 'updateUserPaymentDetails']),

    handleSavePaymentDetailsCallback () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        notify.error(`Some fields failed validation. Please fix them and try again`)
        return Promise.resolve()
      }

      let omitted = ['id']
      switch (this.user.region.shortname) {
        case this.$regionNameAu:
          omitted = ['id', 'iban_number', 'aba_routing_number']
          break
        case this.$regionNameUk:
          omitted = ['id', 'aba_routing_number', 'abn', 'bsb_number']
          break
        case this.$regionNameUs:
          omitted = ['id', 'iban_number', 'abn', 'bsb_number']
          break
      }
      if (this.stateSwiftCode === '' || !this.$swiftCode) {
        omitted.push('swift_code')
      }
      if (!this.$superannuationNumber) {
        omitted.push('superannuation_number')
        omitted.push('member_fund')
        omitted.push('member_number')
        omitted.push('spin_number')
      }
      return this.updateUserPaymentDetails({
        id: this.user.id,
        payload: omit(this.paymentDetails, omitted)
      }).then(() => {
        notify.success('Successfully created payment details')
      }).catch((errors) => {
        notify.error('Sorry something went wrong saving your changes, please try again.')
        if (errors.response) {
          handleServerErrors(errors, this.errors)
        } else {
          throw errors
        }
      })
    }
  }
}
</script>
